import React from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import {
  Row,
  Col,
  Radio,
  Modal,
  Button, FormControl } from 'react-bootstrap';
import Label from '@/component/form/Label.jsx';
import { getSimpleListWrapper } from '@/component/dict/simple/SimpleWrapper';
import { REF_NAME, REF_PATH } from '@/component/dict/simple/topmanager/Const';

class TopManagerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.renderTopManagerRows = this.renderTopManagerRows.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.state = { selectedId: null, searchValue: '' };
  }

  componentWillMount() {
    getSimpleListWrapper(REF_NAME, REF_PATH);
  }

  componentWillReceiveProps(props) {
    if (props.show) {
      this.setState({ selectedId: null, searchValue: '' });
    }
  }

  onSelect() {
    this.props.onSelect(this.state.selectedId, this.props.idx, this.state.note);
  }

  onChange(id) {
    return () => this.setState({ selectedId: id });
  }

  onSearch(event) {
    const searchValue = event.target.value;
    const data = this.props.data.filter(d => !d.get('hidden')
    && (!searchValue || d.get('name').toLowerCase()
      .includes(searchValue.toLowerCase())));
    let selectedItemPresent = true;
    if (this.state.selectedId || this.state.selectedId === 0) {
      selectedItemPresent = !!data.find(d => d.get('id') == this.state.selectedId);
    }
    this.setState({ searchValue, data,
      selectedId: selectedItemPresent ? this.state.selectedId : null });
  }

  renderTopManagerRows() {
    let data = this.state.data || this.props.data;
    data = data.sort((a, b) => a.get('name', '').localeCompare(b.get('name', '')));
    return (
      <div>
        {data.map((r, idx) => (
          <Row style={{ paddingLeft: '20px', borderBottom: '1px dotted lightgray' }}>
            <div>
              <Radio
                id={`selectRadio${idx}`} name="selectRadio" inline
                style={{ display: 'flex', alignItems: 'center' }}
                onChange={this.onChange(r.get('id'))}
                checked={r.get('id') == this.state.selectedId}
              >
                <h5>{r.get('name')}</h5>
              </Radio>
            </div>
            {r.get('id') == this.props.expiredId ?
              <div style={{ display: 'table-cell', paddingLeft: '30px', color: 'red' }}>
                  Approval request expired
              </div> : <div />
            }
            {r.get('id') == this.props.declinedId ?
              <div style={{ display: 'table-cell', paddingLeft: '30px', color: 'red' }}>
                Approval request declined
              </div> : <div />
            }
          </Row>
        ))}
      </div>
    );
  }

  render() {
    const buttonStyle = { width: '71px', height: '30px', padding: '2px 6px' };
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header>
          <Row>
            <Col md={8}>
              <div>Top manager select</div>
            </Col>
            <Col md={4}>
              <FormControl
                type="text"
                onChange={this.onSearch}
                placeholder="Search..."
                style={{ padding: '4px 6px', height: '30px' }}
              />
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body
          style={{ paddingTop: 0, paddingBottom: 0 }}
        >
          <div style={{ maxHeight: '50vh', overflowY: 'scroll', overflowX: 'hidden' }}>
            {this.renderTopManagerRows()}
          </div>
          <div>
            <Label label="Note" vertical sm={12}>
              <FormControl
                style={{ resize: 'none' }}
                componentClass="textarea"
                rows={4}
                onChange={(e) => this.setState({ note: e.target.value })}
              />
            </Label>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ padding: '10px' }}>
          <Button onClick={this.props.onHide} style={buttonStyle}>Cancel</Button>
          <Button
            bsStyle="primary"
            disabled={!this.state.selectedId && this.state.selectedId >= 0}
            onClick={this.onSelect}
            style={buttonStyle}
          >Select</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
TopManagerSelect.propTypes = {
  data: React.PropTypes.object,
  show: React.PropTypes.bool,
  onHide: React.PropTypes.func,
  onSelect: React.PropTypes.func,
  idx: React.PropTypes.number,
  expiredId: React.PropTypes.number,
  declinedId: React.PropTypes.number,
};
export default connect((store => ({
  data: store.getIn(['references', 'simple', REF_PATH], new List()),
})))(TopManagerSelect);
